import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    position: relative;
    width: 100%;

    .dropzone {
        width: 100%;
        display: block;
        text-align: center;
        position: relative;

        .dropzone-value {
            background: white;
            border-radius: .5em;
            overflow: hidden;

            .dropzone-placeholder {
                font-weight: 300;
                color: #FFFFFF;
                font-size: 1.1em;
                padding: 2em;
                background-color: #67676f;
                cursor: pointer;

                @media (pointer: fine) {
                    &:hover {
                        background-color: #7d7d84;
                    }
                }
            }
        }
    }

    .dropzone-list {
        .dropzone-list-element {
            &:first-of-type {
                margin-top: 1em;
            }

            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1em;
            margin-bottom: 1em;
            border-radius: 1em;
            background-color: #4e5057;

            .dropzone-list-element-image {
                display: flex;
                align-items: center;
                width: fit-content;
                height: 50px;
                max-width: 200px;
                position: relative;
                color: ${vars.colorTextLight};
                transform-origin: center;

                img {
                    transition: transform 100ms ease;
                    max-width: 100%;
                    max-height: 100%;

                    @media (pointer: fine) {
                        &:hover {
                            transform: scale(1.1);
                        }
                    }
                }
            }

            .dropzone-list-element-controls {
                .dropzone-list-element-control {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: rgb(176, 147, 101);
                    padding: .5em 2em;
                    color: white;
                    border-radius: .5em;
                    cursor: pointer;

                    @media (pointer: fine) {
                        &:hover {
                            background-color: rgb(208, 175, 127);
                        }
                    }

                    .dropzone-list-element-control-label {
                        margin-right: .5em;
                    }
                }
            }

            &:last-of-type {
                margin-bottom: 0;
                border-bottom: none;
            }
        }
    }

    &.disabled {
        .dropzone-list {
            .dropzone-list-element {
                background-color: #4e5057;
            }
        }
    }
`;
